import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

import { REQUIREMENT_INCLUDE_RESOURCE } from "../constants";
import {
  requirementIncludeSchema,
  type RequirementResponse,
  requirementResponseSchema,
} from "../types";

const getRequirementRequestQuerySchema = z.object({
  include: requirementIncludeSchema,
});

export function useGetRequirement(
  requirementId?: string,
  options: UseGetQueryOptions<RequirementResponse> = {}
): UseQueryResult<RequirementResponse> {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL}/requirements/${requirementId}`,
    queryParams: { include: [REQUIREMENT_INCLUDE_RESOURCE.prerequisiteActions] },
    requestSchema: getRequirementRequestQuerySchema,
    responseSchema: requirementResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_REQUIREMENT_FAILURE,
    },
    enabled: isDefined(requirementId),
    refetchOnWindowFocus: false,
    ...options,
  });
}
